import { ReadFile } from '@paragon/client-tools';
import { ComponentDesign, PlateTypeProperties } from '@paragon/contract-library';

import { DesignService } from './connections';

export interface Truckload {
  readonly width: number;
  readonly length: number;
  readonly height: number;
  readonly componentDesignsAndTransformationMatrices: readonly ComponentDesignAndTransformationMatrix[];
}

export interface ComponentDesignAndTransformationMatrix {
  readonly componentDesign: ComponentDesign;
  readonly plateTypeProperties: { [getPlateTypeStringResult: string]: PlateTypeProperties | undefined };
  readonly transformationMatrices: readonly number[][];
}

export default function pPostUploadFiles(files: readonly ReadFile[]) {
  const filesForUpload = files.map((file) => ({
    contents: file.contents,
    filename: `${file.filename}.${file.filetype}`,
  }));
  return DesignService.post<readonly Truckload[]>('packing/pack', { data: filesForUpload });
}
